import React from 'react';

export const ProductDetailSkeleton: React.FC = () => {
  return (
    <section className="transition-colors min-h-screen bg-gradient-to-b from-gray-200 to-gray-100 animate-pulse">
      <div
        className="sticky top-0 z-50 transition-all duration-300"
        style={{
          backgroundColor: 'rgba(113, 115, 132, 0.08)',
          backdropFilter: 'blur(37px)',
          WebkitBackdropFilter: 'blur(37px)', // For Safari
          borderBottom: '1px solid rgba(0, 0, 0, 0.05)',
        }}
      >
        <div className="page-container flex items-center justify-between py-3">
          <div className="h-6 w-6 bg-gray-300 rounded"></div>
          <div className="flex items-center space-x-1 bg-gray-300 p-1 rounded-full">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="h-8 w-8 bg-gray-400 rounded-full"></div>
            ))}
          </div>
          <div className="h-6 w-1"></div> {/* Spacer */}
        </div>
      </div>

      <div className="page-container">
        <div className="mx-auto p-4 md:p-6 lg:p-8">
          <div className="text-center mb-10">
            <div className="h-36 w-36 bg-gray-300 rounded-full mx-auto mb-6"></div>
            <div className="h-8 bg-gray-300 rounded w-3/4 mx-auto mb-4"></div>
            <div className="h-6 bg-gray-300 rounded w-1/2 mx-auto mb-6"></div>
            <div className="h-5 bg-gray-300 rounded w-1/4 mx-auto mb-8"></div>
            <div className="h-6 bg-gray-300 rounded w-1/3 mx-auto mb-6"></div>

            <div className="flex justify-center space-x-3 mb-8">
              <div className="h-12 bg-gray-300 rounded-md w-40"></div>
              <div className="h-12 bg-gray-300 rounded-md w-40"></div>
            </div>

            <div className="space-y-2 max-w-xl mx-auto mb-6">
              <div className="h-4 bg-gray-300 rounded w-full"></div>
              <div className="h-4 bg-gray-300 rounded w-5/6"></div>
              <div className="h-4 bg-gray-300 rounded w-full"></div>
              <div className="h-4 bg-gray-300 rounded w-3/4"></div>
            </div>

            <div className="h-12 bg-gray-400 rounded-lg w-48 mx-auto mb-14"></div>
          </div>

          <div className="mb-16 rounded-lg overflow-hidden shadow-xl max-w-xl mx-auto">
            <div className="w-full h-64 bg-gray-300"></div>
          </div>

          <div className="text-center mb-12">
            <div className="h-6 bg-gray-300 rounded w-3/5 mx-auto mb-16"></div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {[...Array(3)].map((_, index) => (
              <div
                key={index}
                className="flex flex-col items-center text-center p-4"
              >
                <div className="h-12 w-12 bg-gray-300 rounded-full mb-4"></div>
                <div className="h-4 bg-gray-300 rounded w-3/4"></div>
              </div>
            ))}
          </div>

          {/* Formula Profile Skeleton */}
          <div>
            {[...Array(2)].map((_, sectionIndex) => (
              <div key={sectionIndex} className="mb-12">
                <div className="h-8 bg-gray-300 rounded w-1/2 mb-6"></div>
                <div className="h-4 bg-gray-300 rounded w-full mb-2"></div>
                <div className="h-4 bg-gray-300 rounded w-5/6 mb-6"></div>
                <ul className="list-disc list-inside space-y-4 mb-12">
                  {[...Array(3)].map((_, itemIndex) => (
                    <li
                      key={itemIndex}
                      className="h-4 bg-gray-300 rounded w-full"
                    ></li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mb-12">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-x-4 gap-y-6">
              {[...Array(6)].map((_, index) => (
                <div key={index} className="flex flex-col">
                  <div className="w-12 h-12 bg-gray-300 rounded mb-2"></div>
                  <div className="h-3 bg-gray-300 rounded w-full"></div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="h-3 bg-gray-300 rounded w-full mb-1"></div>
            <div className="h-3 bg-gray-300 rounded w-3/4"></div>
          </div>
        </div>
      </div>
    </section>
  );
};
